import { render, staticRenderFns } from "./CSCustomerBasicStat.vue?vue&type=template&id=565b54a4&lang=pug&"
import script from "./CSCustomerBasicStat.vue?vue&type=script&lang=js&"
export * from "./CSCustomerBasicStat.vue?vue&type=script&lang=js&"
import style0 from "./CSCustomerBasicStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports